<template>
  <div>
    <div v-if="!showModal && embededMode" :style="$parent.getHeaderStyles()">
      <div class="close-btn arrow-back" @click="$parent.goPreStep()"></div>
      <div class>
        <h3>Your Details</h3>
      </div>
    </div>
    <div v-if="!showModal && !embededMode" :style="$parent.getHeaderStyles()">
      <div class="close-btn arrow-back" @click="$parent.goPreStep()"></div>
    </div>
    <div v-if="!showModal && !embededMode" class="row">
      <h3 class="mt-3">Your Details</h3>
    </div>
    <div v-if="!showModal" class="custom-row">
      <div class="request-details-col mr-2">
        <div class="row">
          <div v-if="reservationInfo.venueInfo.Location" class="store-info">
            <div>{{ reservationInfo.venueInfo.name }}</div>
            <div>{{ reservationInfo.venueInfo.Location.Address }}</div>
            <div>
              <span
                v-show="reservationInfo.venueInfo.Location.Suburb"
              >{{ reservationInfo.venueInfo.Location.Suburb }},</span>
              {{ reservationInfo.venueInfo.Location.State }}
              <span
                v-if="reservationInfo.venueInfo.Location.Postcode"
              >
                {{
                reservationInfo.venueInfo.Location.Postcode
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="mt-4 mb-4">
            <div>
              <span>{{ getDate }}</span>
            </div>
            <div>
              <span>{{ reservationInfo.exactTime }}</span>
            </div>
            <div>
              <span>{{(reservationInfo.venueInfo && reservationInfo.venueInfo.GuestLabelOverride) ? reservationInfo.venueInfo.GuestLabelOverride: 'Guest'}}(s): {{ reservationInfo.numberOfGuests }}</span>
            </div>
          </div>
        </div>
        <div v-if="getReservationNote && !isMobile()" class="custom-row">
          <div class="row">
            <div class="store-info">
              Instructions
            </div>
          </div>
        </div>
        <div
          class="row mt-3 justify-content-left instructions"
          v-if="getReservationNote && !isMobile()"
          v-html="getReservationNote"
        ></div>
      </div>
      <div class="user-details-col mt-5">
        <div class="row">
          <div class="form-group">
            <label>First Name</label>
            <input
              maxlength="20"
              v-validate="'required|min:2'"
              class="form-control"
              name="First Name"
              v-model="guestInfo.firstName"
              tabindex="1"
            />
            <span class="required">
              {{ OOErrors.first("First Name") }}
              <i
                v-if="OOErrors.first('First Name')"
                class="fa fa-info-circle"
              ></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Last Name</label>
            <input
              maxlength="20"
              v-validate="'required|min:2'"
              class="form-control"
              v-model="guestInfo.lastName"
              name="Last Name"
              tabindex="2"
            />
            <span class="required">
              {{ OOErrors.first("Last Name") }}
              <i
                v-if="OOErrors.first('Last Name')"
                class="fa fa-info-circle"
              ></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Email Address</label>
            <input
              v-validate="'required|email'"
              class="form-control"
              v-model="guestInfo.email"
              type="email"
              name="Email"
              tabindex="3"
            />
            <span class="required">
              {{ OOErrors.first("Email") }}
              <i
                v-if="OOErrors.first('Email')"
                class="fa fa-info-circle"
              ></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Phone Number</label>
            <div class="phone-field">
              <div class="phone-country" ref="phoneCountry">
                <button
                  type="button"
                  class="form-control phone-country-select"
                  name="Phone Country"
                  aria-label="Country code"
                  :aria-expanded="countryMenuOpen.toString()"
                  tabindex="4"
                  @click="toggleCountryMenu"
                >
                  <span>{{ selectedCountryCode }}</span>
                  <span class="phone-country-caret"></span>
                </button>
                <ul v-show="countryMenuOpen" class="phone-country-menu">
                  <li
                    v-for="country in phoneCountries"
                    :key="country.iso"
                    :class="{ selected: country.iso === guestInfo.countryIso }"
                    @click="selectPhoneCountry(country)"
                  >{{ country.label }}</li>
                </ul>
              </div>
              <input
                v-validate="{ required: true, phone_country: guestInfo.countryIso }"
                class="form-control phone-number-input"
                name="Phone Number"
                onkeypress="if (event.which < 48 || event.which > 57)
          {
              event.preventDefault();
          };"
                v-model="guestInfo.phoneNumber"
                type="tel"
                inputmode="numeric"
                autocomplete="tel-national"
                maxlength="15"
                tabindex="4"
              />
            </div>
            <span class="required">
              {{ OOErrors.first("Phone Number") }}
              <i
                v-if="OOErrors.first('Phone Number')"
                class="fa fa-info-circle"
              ></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label>Special Request (Optional)</label>
            <input class="form-control" placeholder=" " v-model="guestInfo.note" tabindex="5" />
          </div>
        </div>
        <hr v-if="$parent.hasPayment()" />
        <div class="row" v-if="$parent.hasPayment()">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>
                Deposit Amount: {{depositText}}
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="Card Holder Name">Card Holder Name</label>
            <input
              v-validate="'required'"
              id="cardHolder"
              v-model="cardInfo.CardHolder"
              name="Card Holder Name"
              type="text"
              class="form-control"
              tabindex="6"
            />
            <span class="required">
              {{ OOErrors.first("Card Holder Name") }}
              <i
                v-if="OOErrors.first('Card Holder Name')"
                class="fa fa-info-circle"
              ></i>
            </span>


          </div>

          <div class="form-group">

            <div  class="px-2 d-flex flex-row col-lg-8" style="border-radius: 0.3rem; border: 1px solid #ced4da; padding: 0.575rem 0.75rem">
              <div style="width: 100%">
                <div style="color: #495057;" ref="cardInfo" class="card-input align-content-center justify-content-center" id="card-element"></div>

                <div v-if="error" style="padding-top: 8px; color: red; font-size: 12px" id="card-error">
                  {{error}}
                </div>

              </div>
            </div>
          </div>

        </div>
        <div
          v-if="
            configurationInfo.singlePage ||
              (!configurationInfo.singlePage &&
                configurationInfo.wizardIndex == 1)
          "
          class="row"
        >
          <div class="col-12 ml-1 mt-5">
            <label class="checkbox-label">
              I Accept
              <a @click="terms()">terms and conditions</a>
              <input type="checkbox" v-model="termsAndCondiitonChk" tabindex="10" />
              <span class="checkbox-checkmark" :style="getCheckboxStyles(termsAndCondiitonChk)"></span>
            </label>
          </div>
          <div v-if="getReservationNote && isMobile()" class="custom-row">
            <div class="row" style="font-weight: bolder; font-size: 1.1rem">
                Instructions
            </div>
          </div>
          <div
            class="row mt-3 justify-content-left"
            v-if="getReservationNote && isMobile()"
            v-html="getReservationNote"
          ></div>
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="!showModal">
      <div class="col-4 pl-0">
        <button
          class="btn white-button btn-block d-flex justify-content-center align-items-center"
          @click="$parent.goPreStep()"
          tabindex="12"
        >Back</button>
      </div>
      <div class="col-8 pr-0">
        <button
          :disabled="!termsAndCondiitonChk || processing"
          @click="validateBeforeSubmit"
          :class="processing ? 'btn shadow btn-block d-flex justify-content-center align-items-center fontsize' : 'btn shadow btn-block d-flex justify-content-center align-items-center'"
          :style="configurationInfo.Styles.btn"
          tabindex="11"
        >Request reservation
              <span v-show="processing">
                <i class="spin-sm ml-4"></i>
              </span>
         </button>
      </div>
    </div>
    <div v-show="errorMessage != ''" class="row mt-3">
      <h3 class="text-danger mt-4">{{ errorMessage }}</h3>
    </div>
    <div v-if="!showModal && showReservationFooterNote" class="details-notes row">
      <span class="mt-4 footer-notes" v-html="getReservationFooterNote"></span>
    </div>

    <div v-if="showModal">
      <div v-if="showModal && embededMode" :style="$parent.getHeaderStyles()">
        <div class="close-btn arrow-back" @click="closeModal2()"></div>
        <div class>
          <h3>Terms and Conditions</h3>
        </div>
      </div>
      <div v-if="showModal && !embededMode" :style="$parent.getHeaderStyles()">
        <div class="close-btn arrow-back" @click="closeModal2()"></div>
      </div>
      <div v-if="showModal && !embededMode"  class="row">
        <h3 class="mt-3">Terms and Conditions</h3>
      </div>
      <div class="mt-2">
        <div>
          <p v-html="TermsAndConditions"></p>
        </div>
         <div style="width:200px;margin: auto;">
        <button
          @click="closeModal2"
          class="btn shadow btn-block d-flex justify-content-center align-items-center"
          :style="configurationInfo.Styles.btn"
          tabindex="11"
        >OK</button>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from "luxon";
import { Validator } from "vee-validate";
import { DetectMobile } from "./../../helpers/ui/detectmobile";
import { $$ } from "../../helpers/ui/OR_jquery";
import {
  getCountryIsoFromVenue,
  getCountryOptions,
  registerPhoneCountryValidator
} from "../../helpers/validation/phoneHelper";

registerPhoneCountryValidator(Validator);

export default {
  props: {
    stripeStatus: {
      type: Boolean,
      default: true,
    },
    processing: {
       type: Boolean,
       default: false
    },
    embededMode: {
      type: Boolean,
      default: false
    },
    cardInfo: {
      type: Object,
      default: function() {
        return {
          Amount: 0,
          CardHolder: "",
          CardNumber: "",
          ExpireDate: "",
          CVV: "",
          ForceUseSandboxPayment: true
        };
      }
    },
    guestInfo: {
      type: Object,
      default: function() {
        return {
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          countryIso: "AU",
          cardNumber: "",
          yearMonth: "",
          cvv: "",
          note: ""
        };
      }
    },
    validationStatus: {
      type: Object,
      default: function() {
        return {
          reservationInfoValidated: false,
          guestInfoValidated: false,
          firstNameValidated: true,
          lastNameValidated: true,
          phoneValidated: true,
          emailValidated: true
        };
      }
    },
    validationErrors: {
      type: Object,
      default: function() {
        return {
          dateError: "Date cannot be in the past",
          phoneError: "Phone number is invalid",
          firstNameError: "First name is invalid",
          lastNameError: "Last name is invalid",
          emailError: "Email address is invalid"
        };
      }
    },
    reservationInfo: {
      type: Object,
      default: function() {
        return {
          venue: "",
          bookingType: "",
          numberOfGuests: 2,
          date: "",
          time: "",
          storeId: "",
          venueInfo: {}
        };
      }
    },
    configurationInfo: {
      type: Object,
      default: function() {
        return {
          showDeposit: false,
          minimumDepositPerGuest: 20,
          currency: "",
          wizardIndex: 0,
          singlePage: false,
          showVenue: true,
          showBookingType: true,
          defaultDate: "",
          defaultTime: "",
          defaultGuest: "",
          theme: ""
        };
      }
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      termsAndCondiitonChk: false,
      showModal: false,
      stripe: null,
      token: null,
      cardElement: null,
      error: '',
      phoneCountries: getCountryOptions(),
      countryMenuOpen: false
    };
  },
  computed: {
    getDate() {
      var date = DateTime.fromJSDate(new Date(this.reservationInfo.date));
      return date.toFormat("cccc, dd MMMM");
    },
    depositAmount() {
      return this.cardInfo.Amount;
    },
    getReservationNote() {
      if (
        this.reservationInfo.venueInfo &&
        this.reservationInfo.venueInfo.ReservationInstructions
      ) {
        return this.reservationInfo.venueInfo.ReservationInstructions;
      } else return "";
    },
    showReservationFooterNote() {
      return this.reservationInfo.venueInfo &&
        this.reservationInfo.venueInfo.ReservationFooterNotes;
    },
    getReservationFooterNote() {
      return this.showReservationFooterNote ?
        this.reservationInfo.venueInfo.ReservationFooterNotes
        : null;
    },
    depositText() {
      const postfix = this.reservationInfo.numberOfGuests > 1 ? '(s)' : '';
      const defaultLabel = this.reservationInfo.numberOfGuests > 1
        ? 'guests'
        : 'guest';
      const label = this.reservationInfo.venueInfo
        && this.reservationInfo.venueInfo.GuestLabelOverride
        ? this.reservationInfo.venueInfo.GuestLabelOverride.concat(postfix)
        : defaultLabel;
      return '$'.concat(
        this.$parent.paymentValue(),
        ' total for ',
        this.reservationInfo.numberOfGuests,
        ' ',
        label
      );
    },
    cvvMask() {
      return this.stripeStatus ? '####' : '###';
    },
    stripeElements () {
      return this.$stripe.elements();
    },
    canDisplayPayment() {
      return this.$parent.hasPayment();
    },
    getCardElement() {
      return this.cardElement;
    },
    selectedCountryCode() {
      var iso = this.guestInfo.countryIso;
      var match = this.phoneCountries.find(function(country) {
        return country.iso === iso;
      });
      return match ? "+" + match.callingCode : "+61";
    }

  },
  watch: {
    "reservationInfo.numberOfGuests": function() {
      this.cardInfo.Amount =
        this.reservationInfo.numberOfGuests *
        this.reservationInfo.venueInfo.DepositPerGuest;
    },
    // Watch for changes on the computed property
    canDisplayPayment(newVal) {
      if (newVal) {
        // Wait for the DOM to update
        this.$nextTick(() => {
          // Now that the DOM is ready and the condition is true, mount the Stripe element
          this.mountStripeElement();
        });
      }
    },
    "reservationInfo.venueInfo": function() {
      if (!this.guestInfo.phoneNumber) {
        this.initPhoneCountry();
      }
    }
  },
  methods: {
    async validateBeforeSubmit() {
      this.$validator.validateAll().then(async (valid) => {
        if (!valid) return;
        await this.handleBookButton();
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    terms() {
      if (this.reservationInfo.venueInfo.TermsAndConditionsTemplate)
        this.TermsAndConditions = this.reservationInfo.venueInfo.TermsAndConditionsTemplate;
      else
        this.TermsAndConditions =
          "By placing a reservation request, you acknowledge that your contact details entered above (name, phone number, and email address) will be recorded and accessible by " +
          this.reservationInfo.venueInfo.Name +
          ", who will use these details to contact you on the status of your reservation. You also accept that by placing a reservation request online, you are only expressing your interest in a reservation. No reservation is confirmed until a reservation confirmation email has been sent to your email address.";
      this.showModal = true;
    },
    fix2digit(value) {
      return parseFloat(value).toFixed(2);
    },
    closeModal2() {
      this.showModal = false;
    },
    getCheckboxStyles(checked) {
      var styles = [];
      if (checked)
        styles.push(this.configurationInfo.Styles.CommonColorBackground);
      return styles;
    },
    isMobile() {
      return DetectMobile.methods.isMobile();
    },
    handleBookButton() {
      this.$emit('book-button-pressed');
    },
    onPhoneCountryChange() {
      if (this.guestInfo.phoneNumber) {
        this.$validator.validate("Phone Number");
      }
    },
    toggleCountryMenu() {
      this.countryMenuOpen = !this.countryMenuOpen;
    },
    selectPhoneCountry(country) {
      this.guestInfo.countryIso = country.iso;
      this.countryMenuOpen = false;
      this.onPhoneCountryChange();
    },
    onDocumentClick(event) {
      if (!this.countryMenuOpen || !this.$refs.phoneCountry) {
        return;
      }
      if (!this.$refs.phoneCountry.contains(event.target)) {
        this.countryMenuOpen = false;
      }
    },
    initPhoneCountry() {
      if (this.guestInfo.phoneNumber && this.guestInfo.countryIso) {
        return;
      }
      this.$set(
        this.guestInfo,
        "countryIso",
        getCountryIsoFromVenue(this.reservationInfo.venueInfo)
      );
    },
    mountStripeElement() {
      // Ensure not to attempt remounting if already mounted
      if (!this.cardElement) {
        this.cardElement = this.stripeElements.create('card', { hidePostalCode: true });
        this.cardElement.mount('#card-element');
      }
    }
  },
  created() {
    this.initPhoneCountry();
  },
  mounted() {
    this.cardInfo.Amount =
      this.reservationInfo.numberOfGuests *
      this.reservationInfo.venueInfo.DepositPerGuest;
    $$("input[tabindex], textarea[tabindex], button[tabindex]").each(
      function() {
        $$(this).on("keypress", function(e) {
          if (e.keyCode === 13) {
            var nextElement = $$('[tabindex="' + (this.tabIndex + 1) + '"]');
            if (nextElement.length) {
              $$('[tabindex="' + (this.tabIndex + 1) + '"]').focus();
              e.preventDefault();
            } else {
              $$('[tabindex="10"]').focus();
            }
          }
        });
      }
    );

    if (this.canDisplayPayment) {
      this.$nextTick(() => {
        this.mountStripeElement();
      });
    }

    document.addEventListener("click", this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  }

};
</script>
<style scoped>
.phone-field {
  display: flex;
  align-items: stretch;
  overflow: visible;
}
.phone-country {
  position: relative;
  flex: 0 0 auto;
  margin-right: 0.5rem;
}
.phone-country-select {
  width: auto !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.375rem 0.45rem 0.375rem 0.55rem;
  white-space: nowrap;
  cursor: pointer;
  background-color: #fff;
}
.phone-country-caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.3rem;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #6c757d;
}
.phone-country-menu {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  z-index: 30;
  min-width: 16rem;
  max-height: 240px;
  overflow-y: auto;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.3rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.phone-country-menu li {
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  white-space: nowrap;
}
.phone-country-menu li:hover,
.phone-country-menu li.selected {
  background: #f2f2f2;
}
.phone-number-input {
  flex: 1 1 auto;
  width: auto !important;
  min-width: 0;
}
</style>
